import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { IconButton, iconButtonClasses } from "@mui/material";
import { combineSx, toPixelString } from "../../utils/index.js";
import { Box } from "../Box/index.js";
import { iconButtonPadding } from "./icon-button-overrides.js";
const BaseIconButton = ({ Badge, disabled, size = 'medium', variant = 'tertiary', danger = false, children, sx, ...props }, ref)=>/*#__PURE__*/ jsxs(IconButton, {
        ...props,
        ref: ref,
        color: "default",
        disabled: disabled,
        size: size,
        sx: combineSx((theme)=>danger ? dangerStylesByVariant[variant](theme) : stylesByVariant[variant](theme), sx),
        children: [
            children,
            Badge && /*#__PURE__*/ jsx(Box, {
                sx: {
                    position: 'absolute',
                    top: '-12px',
                    right: '-4px'
                },
                children: Badge
            })
        ]
    });
const IconButton_IconButton = /*#__PURE__*/ forwardRef(BaseIconButton);
const commonStyles = {
    [`&.${iconButtonClasses.sizeSmall}`]: {
        padding: toPixelString(iconButtonPadding.small - 1),
        '.MuiSvgIcon-root': {
            width: '16px',
            height: '16px'
        }
    },
    [`&.${iconButtonClasses.sizeMedium}`]: {
        padding: toPixelString(iconButtonPadding.medium - 1),
        '.MuiSvgIcon-root': {
            width: '20px',
            height: '20px'
        }
    }
};
const stylesByVariant = {
    tertiary: (theme)=>({
            color: theme.palette.text.secondary,
            ["&:hover"]: {
                color: theme.palette.text.primary
            },
            [`&.${iconButtonClasses.sizeSmall}`]: {
                '.MuiSvgIcon-root': {
                    width: '16px',
                    height: '16px'
                }
            },
            [`&.${iconButtonClasses.sizeMedium}`]: {
                '.MuiSvgIcon-root': {
                    width: '20px',
                    height: '20px'
                }
            }
        }),
    secondary: (theme)=>({
            ...commonStyles,
            backgroundColor: theme.palette.background.container,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.border.prominent}`,
            ["&:hover"]: {
                backgroundColor: theme.palette.background.hover,
                border: `1px solid ${theme.palette.text.secondary}`
            },
            [`&.${iconButtonClasses.disabled}`]: {
                color: theme.palette.text.disabled,
                border: `1px solid ${theme.palette.border.prominent}`
            }
        })
};
const dangerStylesByVariant = {
    tertiary: (theme)=>({
            ...stylesByVariant.tertiary(theme),
            color: theme.palette.status.error.main,
            ["&:hover"]: {
                backgroundColor: theme.palette.status.error.lowContrast
            },
            [`&.${iconButtonClasses.disabled}`]: {
                color: theme.palette.text.disabled
            }
        }),
    secondary: (theme)=>({
            ...stylesByVariant.secondary(theme),
            color: theme.palette.status.error.main,
            border: `1px solid ${theme.palette.status.error.main}`,
            background: theme.palette.background.container,
            ["&:hover"]: {
                backgroundColor: theme.palette.status.error.lowContrast,
                border: `1px solid ${theme.palette.status.error.main}`
            },
            [`&.${iconButtonClasses.disabled}`]: {
                color: theme.palette.text.disabled,
                border: `1px solid ${theme.palette.border.prominent}`
            }
        })
};
export { IconButton_IconButton as IconButton };

//# sourceMappingURL=IconButton.js.map